document.addEventListener('click', function(e){
  const thumb=e.target.closest('[data-gallery-thumb]');
  if(thumb){
    const root=thumb.closest('[data-product-gallery]');
    const main=root && root.querySelector('[data-gallery-main]');
    if(main){ main.src=thumb.dataset.src; main.srcset=''; }
    root.querySelectorAll('[data-gallery-thumb]').forEach(el=>el.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }
  const arrow=e.target.closest('[data-slider-direction]');
  if(arrow){
    const wrap=arrow.closest('[data-slider-wrap]');
    const slider=wrap && wrap.querySelector('[data-horizontal-slider]');
    if(slider){
      const dir=arrow.dataset.sliderDirection==='next'?1:-1;
      slider.scrollBy({left:slider.clientWidth*.8*dir,behavior:'smooth'});
    }
  }
});

document.addEventListener('change', function(e){
  if(e.target.matches('[data-variant-select]')){
    const form=e.target.closest('form');
    const id=form && form.querySelector('input[name="id"]');
    if(id) id.value=e.target.value;
  }
});
